'use client';

import { iconClass, type IconSize } from '@mv/web-ui';
import { cx } from 'class-variance-authority';
import type { CSSProperties } from 'react';
import { assertPayloadType } from '@/modules/utils/assert';
import type { Icon, ThemedIcon } from '@/payload/types';
import styles from './ThemedIcon.module.scss';

export type IconTheme = 'dark' | 'light' | undefined;

export default function ThemedIconImg({
	icon,
	size,
	theme,
}: {
	icon?: ThemedIcon | number | null;
	size?: IconSize | null;
	theme?: IconTheme;
}) {
	if (!icon) return null;

	assertPayloadType<ThemedIcon>(icon);
	assertPayloadType<Icon>(icon.light_theme);
	assertPayloadType<Icon>(icon.dark_theme);

	const styleVars: CSSProperties & {
		'--icon-bg-url-light-theme': string | undefined;
		'--icon-bg-url-dark-theme': string | undefined;
	} = {
		'--icon-bg-url-light-theme': icon.light_theme ? `url("${icon.light_theme.url}")` : undefined,
		'--icon-bg-url-dark-theme': icon.dark_theme ? `url("${icon.dark_theme.url}")` : undefined,
	};

	return (
		<span
			aria-hidden="true"
			className={cx(iconClass({ size: size ?? undefined }), styles.themedIconBg, theme && `${theme}-theme`)}
			style={styleVars}
		/>
	);
}
